/**
 * Base `/api/v1` — quando `VITE_API_URL` não está definido, usa caminho relativo (mesmo host).
 */
export function apiV1Root(): string {
    const raw = (import.meta.env.VITE_API_URL as string | undefined)?.trim();
    if (raw) {
        return raw.replace(/\/+$/, '');
    }
    return '/api/v1';
}

export function apiUrl(suffix: string): string {
    const root = apiV1Root();
    const s = suffix.replace(/^\/+/, '');
    return `${root}/${s}`;
}
